<template>
    <div :class="classes">
        <el-form label-position="right" label-width="160px">
            <el-form-item label="奖品名称">
                <el-input :disabled="disabled" v-model="form.name" show-word-limit maxlength="20" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="积分数" v-if="typeName === '狮币积分'">
                <el-input v-inputLimit:int="{ maxLength: 10, min: 0 }" :disabled="disabled" v-model="form.shiquanCoinPoints" placeholder="请输入积分奖励数"></el-input>
            </el-form-item>
            <el-form-item label="奖品图片">
                <w-upload-image :disabled="disabled" :imgWidth="300" :imgHeight="200" :size="1" v-model="form.prizeImage"></w-upload-image>
            </el-form-item>
            <el-form-item label="状态">
                <el-radio-group @change="() => $forceUpdate()" v-model="form.status" size="small" class="p-state" :disabled="disabled">
                    <el-radio-button label="1">上架中</el-radio-button>
                    <el-radio-button label="-1">已下架</el-radio-button>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { verifyField } from "@/common/utils";

const prefix = "w-user";

export default {
    props: {
        disabled: {
            type: Boolean
        },
        typeName: {
            type: String
        },
        isAdd: Boolean,
        data: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            form: {
                status: 1
            },
            verifyRules: {
                name: [{ required: true, message: "请输入奖品名称" }],
                prizeImage: [{ required: true, message: "请上传奖品图片" }],
                status: [{ required: true, message: "请设置状态" }],
            },
        };
    },
    methods: {
        init() {
            if(this.typeName === '狮币积分') {
                this.verifyRules.shiquanCoinPoints = [{ required: true, message: "请输入积分数" }]
            }

            if (this.isAdd) {
                this.form.status = '1'
            }
        },
        verify() {
            if(verifyField(this.verifyRules, this.form)) {
                return this.form
            }
        }
    },
    created() {
        this.init();
    },
    computed: {
        classes() {
            return [prefix];
        },
    },
    watch: {
        data: {
            handler(val) {
                this.form = val
            },
            deep: true,
            immediate: true
        }
    }
};
</script>

<style lang="scss">
$prefixCls: w-user;

.#{$prefixCls} {
}
</style>
